import './App.css';
import { Routes, Route } from 'react-router-dom';
import AppToaster from './components/AppToaster';
import Home from './pages/home';
import ResultsPage from './pages/resultspage';
import ProtectedRoute from './roots/ProtectedRoute';

function App() {
  return (
    <>
      <AppToaster />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route 
            path="/careers" 
            element={
              <ProtectedRoute>
                <ResultsPage />
              </ProtectedRoute>
            } 
          />
      </Routes>
    </>
  );
}

export default App;